import React from 'react';
import { Icon } from './Icon';

type MenuTriangleProps = {
  isOpen: boolean;
};

export const MenuTriangle: React.FC<MenuTriangleProps> = ({ isOpen }) => {
  return (
    <>
      {isOpen ? (
        <Icon iconName="chevron-up" height="20px" width="20px" ml=".5rem" />
      ) : (
        <Icon iconName="chevron-down" height="20px" width="20px" ml=".5rem" />
      )}
    </>
  );
};
